/* Vendor imports */
import React from 'react'
/* App imports */
import style from './footer.module.less'

const Footer = () => (
  <div className={style.container}>
    &copy; {new Date().getFullYear()} by Chinedu Orie
    <br />
  </div>
)

export default Footer
